import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import TextField from '@mui/material/TextField'
import React, { useEffect, useState } from 'react'
import { classnames } from '../../../../helpers'
import { useStates } from '../../../../StateProvider'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from './autocomplete'
import './autocomplete/auto_complete.css'

const ToSearchBar = (props) => {
  const [inputValue, setInputValue] = React.useState(localStorage.removeItem('toSearchAddress') || '')
  const [address, setAddress] = useState(
    localStorage.removeItem('toSearchAddress') || ''
  )
  const [errorMessage, setErrorMessage] = useState('')
  const [latitude, setLatitude] = useState(null)
  const [longitude, setLongitude] = useState(null)
  const [addressComponent, setAddressComponent] = useState(null)

  const handleChange = (newAddress) => {
    setInputValue(newAddress)
    setAddress(newAddress) // Update the address state with the new input value
    setLatitude(null)
    setLongitude(null)
    setAddressComponent(null)
    setErrorMessage('')
  }

  const { searchFor } = useStates()

  const handleSelect = (selected) => {
    localStorage.removeItem('toSearchAddress', selected)
    setAddress(selected)
    geocodeByAddress(selected)
      .then((res) => {
        res[0].address_components &&
          setAddressComponent(res[0].address_components)
        return getLatLng(res[0])
      })
      .then(async ({ lat, lng }) => {
        setLatitude(lat)
        setLongitude(lng)

        // Call Google Time Zone API
        const timestamp = Math.floor(Date.now() / 1000) // Current timestamp in seconds
        const timeZoneAPI = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${process.env.REACT_APP_GOOGLE_APIS_KEY}`

        try {
          const response = await fetch(timeZoneAPI)
          const data = await response.json()

          // console.log('UTC OffsetTest to:', data)
          if (data.status === 'OK') {
            const rawOffset = data.rawOffset // Base UTC offset in seconds
            const dstOffset = data.dstOffset // Daylight savings offset in seconds
            const totalOffset = rawOffset + dstOffset // Total offset in seconds
            const totalToOffSetFromUtcInMs = totalOffset * 1000
            // Convert offset from seconds to HH:mm format
            const offsetHours = Math.floor(totalOffset / 3600)
            const offsetMinutes = Math.abs((totalOffset % 3600) / 60)
            const formattedOffset = `${offsetHours >= 0 ? '+' : '-'}${String(Math.abs(offsetHours)).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`

            // Store UTC Offset in state
            props.setUtcToOffset(formattedOffset) // --> "+05:30"
            props.setToOffsetFromUtcInMs(totalToOffSetFromUtcInMs)
            props.setToTimeZone(data?.timeZoneId) // Use timeZoneId instead of abbreviation
          } else {
            console.error('Time Zone API Error:', data.status)
          }
        } catch (error) {
          console.error('Error fetching time zone:', error)
        }
      })
      .catch((error) => {
        console.error('error', error)
      })
  }

  const handleError = (status, clearSuggestions) => {
    let errorMessage = status
    if (status === 'ZERO_RESULTS') {
      errorMessage = 'This address is not found, try to search USA locations'
    }
    setErrorMessage(errorMessage)
    clearSuggestions()
  }

  useEffect(() => {
    props.setLat(latitude)
    props.setLong(longitude)
    if (props?.setAddress) {
      props?.setAddress(addressComponent)
    }
  }, [latitude, longitude, addressComponent, props])

  useEffect(() => {
    geocodeByAddress(address)
      .then((res) => {
        res[0].address_components &&
          setAddressComponent(res[0].address_components)
        return getLatLng(res[0])
      })
      .then(({ lat, lng }) => {
        setLatitude(lat)
        setLongitude(lng)
      })
      .catch((error) => {
        console.error('error', error)
      })
  }, [address])

  useEffect(() => {
    if (inputValue === '') {
      localStorage.removeItem('toSearchAddress', '')
    }
  }, [inputValue])

  return (
    <div>
      <PlacesAutocomplete
        onChange={handleChange}
        value={address} // Use address state as the value for PlacesAutocomplete
        onSelect={handleSelect}
        onError={handleError}
        shouldFetchSuggestions={address?.length > 2}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps }) => {
          return (
            <div className="Demo__search-bar-container">
              <div className="Demo__search-input-container">
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  value={inputValue}
                  onChange={(e) => {
                    setInputValue(e.target.value)
                    setAddress(e.target.value)
                  }}
                  {...getInputProps({
                    placeholder: 'Search Places...',
                    className: 'Demo__search-input'
                  })}
                  fullWidth
                  sx={{
                    width:
                      searchFor === 'setPosition' ? '370px !important' : '100%',
                    paddingLeft: '0px !important',
                    margin: '0 auto',
                    '& .MuiInputLabel-root': {
                      marginLeft: '-15px',
                      color: '#a3a3a3b3',
                      fontFamily: '"Poppins", sans-serif',
                      borderWidth: '0.3px'
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      marginLeft: '-15px',
                      color: '#a3a3a3b3',
                      fontFamily: '"Poppins", sans-serif'
                    },
                    '& .MuiOutlinedInput-root': {
                      fontFamily: '"Poppins", sans-serif',
                      '& fieldset': {
                        borderColor: '#a3a3a3b3' // Default border color
                      },
                      '&:hover fieldset': {
                        borderColor: '#a3a3a3b3', // Border color on hover
                        borderWidth: '0.3px'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#a3a3a3b3', // Border color on focus
                        borderWidth: '0.3px'
                        // boxShadow: '1px 1px 7px 0px #00000017' // Apply shadow on focus
                      }
                    },
                    '& .MuiInputBase-input::placeholder': {
                      fontFamily: '"Poppins", sans-serif',
                      fontSize: '12px',
                      fontWeight: '400',
                      color: '#858585'
                    }
                  }}
                />
              </div>
              {suggestions.length > 0 && (
                <div className="Demo__autocomplete-container">
                  {suggestions.map((suggestion) => {
                    const className = classnames('Demo__suggestion-item', {
                      'Demo__suggestion-item--active': suggestion.active
                    })
                    return (
                      <div
                        key={suggestion.placeId}
                        {...getSuggestionItemProps(suggestion, { className })}
                        style={{
                          margin: '.4rem 0',
                          display: 'flex',
                          alignItems: 'flex-start',
                          justifyContent: 'flex-start',
                          fontFamily: "'Poppins', sans-serif !important"
                        }}
                      >
                        <div>
                          <LocationOnOutlinedIcon className="location_icon" />
                        </div>
                        <div>
                          <strong>
                            {suggestion.formattedSuggestion.mainText}
                          </strong>
                          <small className="small_text">
                            {suggestion.formattedSuggestion.secondaryText}
                          </small>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </div>
          )
        }}
      </PlacesAutocomplete>
      {errorMessage.length > 0 && (
        <div className="Demo__error-message">{errorMessage}</div>
      )}
    </div>
  )
}

export default ToSearchBar
